import * as api from '../../api';

export const updateWebVersionActions = api.fetchActions('userPreferences', 'update-web-version');

export const actionTypes = {
  ...updateWebVersionActions.actionTypes,
};

export const updateWebVersion = (participantId, input) =>
  api.patchThunk(`/participants/${participantId}/web-version`, input, updateWebVersionActions);



// WEBPACK FOOTER //
// src/acct/preferences/user-preferences.actions.js